import React from "react";

import { getShoppingCartRedirect } from "@utils/configuration/aem";

import { useGranite } from "@redux/modules/value/translations/translations.provider";

type AddToCardModalFooterProps = {
    onModalClose: React.MouseEventHandler<HTMLAnchorElement>;
};

const AddToCardModalFooter = ({ onModalClose }: AddToCardModalFooterProps) => {
    const { t } = useGranite();
    return (
        <div className="container p-0 m-0 pt-3">
            <div className="row align-items-center">
                <div className="col-5 col-lg-8">
                    <a
                        data-test="addToCartModal-link-cancel"
                        href="#"
                        className="text-break"
                        onClick={onModalClose}
                    >
                        <i className="las la-angle-left" />
                        {t("product.addtocart.modal.cancel")}
                    </a>
                </div>
                <div className="col-7 col-lg-4">
                    <button
                        data-test="addToCartModal-button-confirm"
                        className="btn btn-secondary w-100"
                        style={{ wordBreak: "break-word" }}
                        onClick={() =>
                            location.replace(getShoppingCartRedirect())
                        }
                    >
                        {t("product.addtocart.modal.confirm")}
                    </button>
                </div>
            </div>
        </div>
    );
};

export { AddToCardModalFooter };
